module.exports = __webpack_public_path__ + "assets/img/role_name-ed78b368.png";